module.exports = __webpack_public_path__ + "img/Angola.d9500873.svg";